import { Box, Drawer, styled, useTheme } from '@mui/material';
import { useContext } from 'react';
import Logo from 'src/components/Logo';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';

import SidebarWorkspaces from '../SpaceSwitcher';
import SidebarMenu from './SidebarMenu';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.sidebar.textColor};
        background: ${theme.sidebar.background};
        box-shadow: ${theme.sidebar.boxShadow};
        position: relative;
        z-index: 7;
        height: 100%;
`
);

const LogoWrapper = styled(Box)(
  ({ theme }) => `
    padding: ${theme.spacing(1)};
  `
);

const TopSection = styled(Box)(
  ({ theme }) => `
      margin: ${theme.spacing(4)} ${theme.spacing(2)} ${theme.spacing(2)};
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(2)};
      align-items: start;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  return (
    <Drawer
      sx={{
        boxShadow: `${theme.sidebar.boxShadow}`
      }}
      anchor={theme.direction === 'rtl' ? 'right' : 'left'}
      open={sidebarToggle}
      onClose={closeSidebar}
      variant="temporary"
      elevation={9}
    >
      <SidebarWrapper>
        <Scrollbar>
          <TopSection>
            <LogoWrapper>
              <Logo variant="text" height={32} />
            </LogoWrapper>
            <SidebarWorkspaces />
          </TopSection>
          <SidebarMenu />
        </Scrollbar>
      </SidebarWrapper>
    </Drawer>
  );
}

export default Sidebar;
